export interface NotificationsListQuery {
  is_action_required?: boolean;
  patient_uuid?: string;
  therapist_uuid?: string;
  view_list?: boolean;
  is_read?: boolean;
  is_action_required_completed?: boolean;
  page_size?: number;
  page?: number;
}

export interface NotificationApi {
  uuid: string;
  created_at: number;
  updated_at: number | null;
  event_type: ACNotificationTypeApi;
  metadata: NotificationMetadata;
  is_read: boolean;
  is_action_required: boolean;
  is_action_required_completed: boolean;
  patient_uuid: string;
  therapist_uuid: string;
  title: string;
  message: string;
  link: string | null;
}

interface NotificationMetadata {
  username?: string;
  form_name?: string;
  date?: number;
  user_questionnaire_uuid?: string;
  user_uuid?: string;
  plan_uuid?: string;
  chat_uuid?: string;
  plan_title?: string;
  therapist_name?: string;
}

export interface UpdateNotificationStatusQuery {
  uuid: string;
  is_read: boolean;
}

export enum ACNotificationTypeApi {
  SUBSCRIPTION_CANCELED_BY_USER = "subscription_canceled_by_user",
  SUBSCRIPTION_CANCELED_PAYMENT_FAILED = "subscription_canceled_payment_failed",
  PAYMENT_RECEIVED = "payment_received",
  ACCOUNT_DELETED = "account_deleted",
  PATIENT_REASSIGNED = "patient_reassigned",
  FORM_COMPLETED = "form_completed",
  FORM_RECEIVED_THERAPIST = "form_received_therapist",
  PAYMENT_ERROR_THERAPIST = "payment_error_therapist",
  BREAK_ENDED_THERAPIST = "break_ended_therapist",
  PLAN_SENT = "plan_sent",
  NEW_APPOINTMENT_THERAPIST = "new_appointment_therapist",
  APPOINTMENT_DELETED_THERAPIST = "appointment_deleted_therapist",
  ASAP_ACCEPTED = "asap_accepted",
  CI_ACCEPTED = "ci_accepted",
  SUBSCRIPTION_TERMINATED_BY_USER = "subscription_terminated_by_user",
  SUBSCRIPTION_TERMINATED_PAYMENT_FAILED = "subscription_terminated_payment_failed",
  CHAT_END_IN_ONE_DAY = "chat_end_in_one_day",
  PAYMENT_MADE = "payment_made",
  PAYMENT_ERROR_PATIENT = "payment_error_patient",
  TRIAL_WEEK = "trial_week",
  FORM_RECEIVED_PATIENT = "form_received_patient",
  RETURN_ORDER = "return_order",
  NEW_REFERRAL = "new_referral",
  PLAN_CHANGED = "plan_changed",
  NEXT_APPOINTMENT = "next_appointment",
  BREAK_CREATED = "break_created",
  BREAK_STARTED = "break_started",
  BREAK_ENDED_PATIENT = "break_ended_patient",
  NEW_PLAN_AVAILABLE = "new_plan_available",
  NEW_APPOINTMENT_PATIENT = "new_appointment_patient",
  APPOINTMENT_DELETED_PATIENT = "appointment_deleted_patient",
  ASAP_RECEIVED = "asap_received",
  CI_RECEIVED = "ci_received",
  REFUND_DONE_THERAPIST = "refund_done_therapist",
  SUBSCRIPTION_TERMINATED_REFUND_FAILED = "subscription_terminated_refund_failed",
  REFUND_DONE_PATIENT = "refund_done_patient",
  REFUND_DONE_2_PATIENT = "refund_done_2_patient",
  NEW_REFERRAL_THERAPIST = "new_referral_therapist",
  SESSION_REGISTERED_THERAPIST = "session_registered_therapist",
  SESSION_DELETED_THERAPIST = "session_deleted_therapist",
  SESSION_REGISTERED_CUSTOMER = "session_registered_customer",
  SESSION_DELETED_CUSTOMER = "session_deleted_customer",
  NEW_COMMUNICATION_WITHOUT_PUSH_CUSTOMER = "new_communication_without_push_customer",
  NEW_COMMUNICATION_WITH_PUSH_CUSTOMER = "new_communication_with_push_customer",
  NEW_COMMUNICATION_WITHOUT_PUSH_THERAPIST = "new_communication_without_push_therapist",
  NEW_COMMUNICATION_WITH_PUSH_THERAPIST = "new_communication_with_push_therapist",
  CLINIC_DISCHARGE_THERAPIST = "clinic_discharge_therapist",
  CLINIC_DISCHARGE = "clinic_discharge",
}
